import React from "react";
import { styled } from "@mui/styles";

import {
    Grid,
    Hidden,
    List,
    ListItemText,
    ListItem as MuiListItem
} from "@mui/material";

const Wrapper = styled('div')(({ theme }) => ({
    padding: `calc(${theme.spacing(1)} / 4) ${theme.spacing(4)}`,
    background: theme.palette.common.white,
    position: 'relative',
}));

const ListItem = styled(MuiListItem)(({ theme }) => ({
    display: 'inline-block',
    width: 'auto',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '&, &:hover, &:active': {
        color: '#000'
    }
}));

function Footer() {
    return (
        <Wrapper>
            <Grid container spacing={0}>
                <Hidden lgDown>
                    <Grid container item xs={12} md={6}>
                        <List>
                            <ListItem component="a" href="#">
                                <ListItemText primary="Support" />
                            </ListItem>
                            <ListItem component="a" href="#">
                                <ListItemText primary="Help Center" />
                            </ListItem>
                            <ListItem component="a" href="#">
                                <ListItemText primary="Privacy" />
                            </ListItem>
                            <ListItem component="a" href="#">
                                <ListItemText primary="Terms of Service" />
                            </ListItem>
                        </List>
                    </Grid>
                </Hidden>
                <Grid container item xs={12} md={6} justifyContent="flex-end">
                    <List>
                        <ListItem>
                            <ListItemText primary={`© ${new Date().getFullYear()} - WorkNest`} />
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </Wrapper>
    );
}

export default Footer;
